import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import { getUserDetailsByUserID, submitFormData } from "../../Utils/adminFunctions";
import { onlyNumber } from "../../Utils/commonFunctions";

let AdminAddUser = () => {
  const [mID, setMID] = useState([]);
  const { uID } = useParams();

  //for dropdowns//
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [contact, setContact] = useState("");
  const [userType, setUserType] = useState("");
  const [email, setEmail] = useState("");
  const [site, setSite] = useState("");
  const [status, setStatus] = useState("");

  const [errorStatus, setErrorStatus] = useState("");

  useEffect(() => {
    async function fetchAPI1() {
      const response = await getUserDetailsByUserID(uID);
      if (response.status == "success") {
        setMID(response.data.manufacturer_id);
        setFirstName(response.data.first_name);
        setLastName(response.data.last_name);
        setContact(response.data.contact);
        setUserType(response.data.user_type);

        setEmail(response.data.email);
        setSite(response.data.site__site_name);
        setStatus(response.data.status);
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  let handleSubmit = () => {
    let errorRequiredFiled = 0;

    if (status === "") {
      setErrorStatus("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }

    const bodyFormData = new FormData();

    bodyFormData.append("contact", contact);
    bodyFormData.append("status", status);
    bodyFormData.append("user_id", uID);

    async function fetchAPI3() {
      const response = await submitFormData("editUser", bodyFormData);

      if (response.status == "success") {
        toast.success(response.message, { autoClose: 1500 });
      }
      if (response.status == "failure") {
        toast.warning(response.message, { autoClose: 1500 });
      }
      if (response.status == "error") {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI3();
  };
  const phonNumberValidation = (number) => {
    const value = onlyNumber(number);
    setContact(value);
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to={"/AdminListUsers/" + mID}
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                First Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={firstName}
                                placeholder="First Name"
                                disabled
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Last Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={lastName}
                                placeholder="Last Name"
                                disabled
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Contact No.
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={contact}
                                placeholder="Contact No."
                                onChange={(e) => {
                                  phonNumberValidation(e.target.value);
                                }}
                                maxLength={12}
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                User Type<i className="text-danger">*</i>
                              </span>
                              <select
                                className="form-control custom-select"
                                disabled
                                onChange={(e) => {
                                  setUserType(e.target.value);
                                }}
                                value={userType}
                              >
                                <option value="">Select</option>
                                <option value="3">Primary User</option>
                                <option value="2">Secondary User</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Email<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className="form-control"
                                value={email}
                                disabled
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Site<i className="text-danger">*</i>
                              </span>
                              <input
                                className="form-control"
                                type="text"
                                value={site}
                                disabled
                              />
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Status<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control custom-select" +
                                  (errorStatus ? " is-invalid" : "")
                                }
                                onChange={(e) => {
                                  setStatus(e.target.value);
                                  setErrorStatus("");
                                }}
                                value={status}
                              >
                                <option value="">Select</option>
                                <option value="1">Active</option>
                                <option value="0">Inactive</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary pull-right"
                              onClick={handleSubmit}
                            >
                              Update
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddUser;
